import {NotificationTriggerType} from "./notificationTriggerType";
import {NotificationRelativeToType} from "./notificationRelativeToType";

export enum NotificationTriggerLabel {
  'At the beginning of this step'       = NotificationTriggerType.beginning,
  'On submission of the initial form'   = NotificationTriggerType.initialSubmission,
  'On approval of this step'            = NotificationTriggerType.approval,
  'On rejection of this step'           = NotificationTriggerType.rejection,
  'On completion of this step'          = NotificationTriggerType.completion,
  'On completion of the form section'   = NotificationTriggerType.formSectionCompletion,
  'On completion of the form'           = NotificationTriggerType.externalFormCompletion,
  'When payment is processed'           = NotificationTriggerType.payment,
  'When applicant submits check'        = NotificationTriggerType.check,
  'On $actionName'                      = NotificationTriggerType.action,
  'Upon SLA timeframe'                  = NotificationTriggerType.sla,
  'On a relative date'                  = NotificationTriggerType.relative,
  'Upon assignment'                     = NotificationTriggerType.assignment,
}

export enum NotificationRelativeTriggerLabel {
  'Deadline' = NotificationRelativeToType.slaDeadline,
  'Goal' = NotificationRelativeToType.slaGoal,
  'The start of this step' = NotificationRelativeToType.stepStart,
  'The end of this step' = NotificationRelativeToType.stepEnd
}
